import MultipleUsersAssociationInput from "./MultipleUsersAssociationInput";

export default MultipleUsersAssociationInput;
